import { residentManagementEmarRoutePrefixes } from "../platform/routes/products/residentManagementEmarRoutes";
import { staffCaregiverHiringRoutePrefixes } from "../platform/routes/products/staffCaregiverHiringRoutes";
import { referralCareDirectoryRoutePrefixes } from "../platform/routes/products/referralCareDirectoryRoutes";
import { schedulingBookingsRoutePrefixes } from "../platform/routes/products/schedulingBookingsRoutes";
import { walletRoutePrefixes } from "../platform/routes/products/walletRoutes";
import { conversationalBotRoutePrefixes } from "../platform/routes/products/conversationalBotRoutes";

export const PRODUCT_REGISTRY = [
  {
    id: "residentManagementEmar",
    label: "Resident Management & eMAR",
    routePrefixes: residentManagementEmarRoutePrefixes,
  },
  {
    id: "staffCaregiverHiring",
    label: "Staff & Caregiver Hiring",
    routePrefixes: staffCaregiverHiringRoutePrefixes,
  },
  {
    id: "referralCareDirectory",
    label: "Care Listings",
    routePrefixes: referralCareDirectoryRoutePrefixes,
  },
  {
    id: "schedulingBookings",
    label: "Scheduling & Bookings",
    routePrefixes: schedulingBookingsRoutePrefixes,
  },
  {
    id: "wallet",
    label: "Wallet",
    routePrefixes: walletRoutePrefixes,
  },
  {
    id: "conversationalBot",
    label: "Conversational Bot",
    routePrefixes: conversationalBotRoutePrefixes,
  },
];

export const PRODUCT_IDS = PRODUCT_REGISTRY.map((product) => product.id);
